import React, { useEffect, useMemo, useState, useCallback } from 'react';
import {  createLicense, deleteLicense, GetLicensesList, RefrechLicense, SendLicense, updateLicense, SendEmail } from '../api/licenses';
import PageHeader from '../components/PageHeader';
import StatCard from '../components/StatCard';
import Table from '../components/Table';
import Button from '../components/Button';
import Input from '../components/Input';
import Select from '../components/Select';
import Chip from '../components/Chip';
import Alert from '../components/Alert';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '../components/Dialog';
import Snackbar from '../components/Snackbar';
import { format, isPast, parseISO } from 'date-fns';
import { pl } from 'date-fns/locale';
import { useAuth } from '../store/auth';
import RowActions from '../components/RowActions';
import TableMarketing from '../components/TableMarketing';
import { listManagmentMarketing } from '../api/Functions/marketing'; 
import PageHeaderPortal from '../components/PageHeaderPortal';


export default function MarketingSettlement() {
  const [rows, setRows] = useState([]);
  const [renevals, setRanavals] = useState([]);
  const [loading, setLoading] = useState(true);
const [editedRows, setEditedRows] = useState({});
const [SumMArketing, setSumMarketing] = useState(0);
const [emptyInvoices, setEmptyInvoices] = useState(0);
    const [Rozliczono, setRozliczono] = useState(0);
      const [Zostało, setZostalo] = useState(0);

  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth()+1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [invoiceNumber, setInvoiceNumber] = useState("");

  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', role: 'user' });
  const [toast, setToast] = useState({ open: false, message: "", severity: "success" });
  const LicenseStatusChip = ({ dorozliczeniamn, rozliczono, fv_number_value }) => {
     if (Number(dorozliczeniamn) == 0) {
  return <Chip color="success" size="small" label="Rozliczone" />;
  }
  if (Number(rozliczono) < Number(dorozliczeniamn)) {
    return <Chip color="error" size="small" label="Nie rozliczone" />;
  }

  if (!fv_number_value || fv_number_value === "BRAK") {
    return <Chip color="warning" size="small" label="Brak faktury" />;
  }

  return <Chip color="success" size="small" label="Rozliczone" />;
};
 const onEdit = useCallback((row) => {
    setEditing(row);
    setForm({ client_email: row.client_email, shop_name: row.shop_name, nip: row.nip, shop_phone: row.shop_phone, licenseId: row.licenseId, license_name: row.license_name, licDays: row.licDays , userID:row.userID});
    setOpen(true);
  }, []);
  const onRefresh = useCallback(async (row) => {
    await RefrechLicense(row);
    fetchData();

  }, []);
  const onSendEmail = useCallback(async () => {
    await SendEmail();
   

  }, []);
  const onSendLicense = useCallback(async (row) => {
    await SendLicense(row.id);
    setToast({ open: true, message: 'Wysłano licencję do klienta', severity: 'success' });
    fetchData();
  }, []);

   const fetchData = async () => {
      setLoading(true);
      try {
        const data = await GetLicensesList();
  
      //  console.log(data);
          // 🔹 Dopasowanie pól z API do tych, które tabela rozumie
      const mapped = data.data.map(item => ({
        id: item.subscriber_id,
        name: item.license_name,                // ← nazwa licencji
        client_email: item.client_email,          // ← klient
        accountManager: item.us_name,           // ← opiekun
        shop_expireDate: item.shop_expireDate,  // ← data wygasania
        last_login: item.last_login, // ← data istatniego logowanai
        login_data: item.login_data,
        shop_name: item.shop_name,              // ← nazwa sklepu
        active: item.active,  
        nip: item.nip,
        shop_phone: item.shop_phone,  
        licenseId: item.licenseId,
        license_name: item.license_name,
        licDays:item.licDays,
        newAcount: item.newAcount,
        userID: item.UserId,
        vendorId: item.vendorId,
                // ← aktywność jako boolean
        // jeśli chcesz, możesz też dodać seats / assigned / price itd.
      }));
        setRows(mapped);
      } finally {
        setLoading(false);
      }
    };
    const handleInputChange = (id, field, value) => {
  setEditedRows((prev) => ({
    ...prev,
    [id]: {
      ...prev[id],
      [field]: value,
      changed: true,
    },
  }));
};useEffect(() => {
  setSumMarketing(filteredLicenses.reduce((acc, item) => acc + Number(item.marketing_value || 0), 0));
  setRozliczono(filteredLicenses.reduce((acc, item) => acc + Number(item.used_marketing_value || 0), 0));
  setZostalo(filteredLicenses.reduce((acc, item) => acc + (Number(item.marketing_value || 0) - Number(item.used_marketing_value || 0)), 0));
setEmptyInvoices(
  filteredLicenses.reduce((acc, item) => {
    if (item.marketing_value === 0) return acc; // pomiń ten przypadek
    if (item.fv_number_value === "BRAK" || item.fv_number_value === "") {
      return acc + 1;
    }
    return acc;
  }, 0)
);}, [rows, selectedMonth, selectedYear]);
  useEffect(() => {
    const fetchData = async () => {
      try {
       const data = await listManagmentMarketing();
        setRows(data);

      
        
      } catch (e) {
        console.error("Błąd pobierania danych", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // 📊 Filtrowanie licencji wg miesiąca
  const filteredLicenses = useMemo(() => {
    return rows.filter((r) => {


   //  console.log(r);
      const d = new Date(String(r.date_from).replace(" ", "T"));
      return (
        d.getMonth() + 1 === selectedMonth && d.getFullYear() === selectedYear
      );
    });
  }, [rows, selectedMonth, selectedYear]);


  // 📅 Lista miesięcy do wyboru
  const months = [ 
    { value: 1, label: "Styczeń" },
    { value: 2, label: "Luty" },
    { value: 3, label: "Marzec" },
    { value: 4, label: "Kwiecień" },
    { value: 5, label: "Maj" },
    { value: 6, label: "Czerwiec" },
    { value: 7, label: "Lipiec" },
    { value: 8, label: "Sierpień" },
    { value: 9, label: "Wrzesień" },
    { value: 10, label: "Październik" },
    { value: 11, label: "Listopad" },
    { value: 12, label: "Grudzień" },
  ];

const columns = [
  { field: 'CompnyName', headerName: 'Dystrybutor' },
  { field: 'provision_value', headerName: 'Prowizje' },
  { field: 'marketing_value', headerName: 'Marketing' },

  {
    field: 'used_marketing_value',
    headerName: 'Rozliczono',
    renderCell: (params) => {
      const row = params.row;
       if (row.marketing_value === 0) {
      return <span className="text-gray-400">-</span>;
    }
      const currentValue =
        editedRows[row.id]?.used_marketing_value ?? row.used_marketing_value;

      return (
        <Input
          size="small"
          value={currentValue}
          
           onChange={(e) => {
  const value = e.target.value;
  
  // aktualizacja używanego marketing_value
  setRows(prev => prev.map(r => 
    r.id === row.id ? { ...r, used_marketing_value: value } : r
  ));

  // dodatkowa funkcja np. aktualizacja fv_number_value
  handleInputChange(row.id, 'used_marketing_value', e.target.value);
}}
          placeholder="Wpisz kwotę"
        />
      );
    },
  },
  {
    field: 'fv_number_value',
    headerName: 'Numer faktury',
    renderCell: (params) => {
      const row = params.row;
      const currentValue =
        editedRows[row.id]?.fv_number_value ?? row.fv_number_value;
  if (row.marketing_value === 0) {
      return <span className="text-gray-400">-</span>;
    }
      return (
        <Input
          size="small"
          value={currentValue}
         onChange={(e) => {
  const value = e.target.value;
  
  // aktualizacja używanego marketing_value
  setRows(prev => prev.map(r => 
    r.id === row.id ? { ...r, fv_number_value: value } : r
  ));

  // dodatkowa funkcja np. aktualizacja fv_number_value
  handleInputChange(row.id, 'fv_number_value', e.target.value);
}}
          placeholder="np. FV/12/2025"
        />
      );
    },
  },
  {
    field: 'dates',
    headerName: 'Zakres dat',
    renderCell: (params) => {
      const row = params.row;
      return (
        <div className="flex flex-col gap-1 text-gray-700 whitespace-nowrap w-full">
          <div className="flex flex-row justify-between w-full">
            <span className="text-gray-500">Od:</span>
            <span className="font-medium text-gray-900">
              {new Date(row.date_from).toLocaleDateString('pl-PL')}
            </span>
          </div>
          <div className="flex flex-row justify-between w-full">
            <span className="text-gray-500">Do:</span>
            <span className="font-medium text-gray-900">
              {new Date(row.date_to).toLocaleDateString('pl-PL')}
            </span>
          </div>
        </div>
      );
    },
  },
  {
  field: 'status',
  headerName: 'Status',
  renderCell: (params) => {
    const row = params.row;
    const edited = editedRows[row.id] || {};

    const usedMarketing = Number(edited.used_marketing_value ?? row.used_marketing_value);
    const marketingValue = Number(row.marketing_value);
    const fvNumber = edited.fv_number_value ?? row.fv_number_value ?? '';

    return (
      <LicenseStatusChip
        rozliczono={usedMarketing}
        dorozliczeniamn={marketingValue}
        fv_number_value={fvNumber}
      />
    );
  },
},
  {
    field: 'actions',
    headerName: 'Akcje',
    renderCell: (params) => {
      const row = params.row;
      const edited = editedRows[row.id];
      const usedMarketing = Number(
        edited?.used_marketing_value ?? row.used_marketing_value
      );
      const marketingValue = Number(row.marketing_value);
      const invoiceNumber =
        edited?.fv_number_value ?? row.fv_number_value ?? '';

      const isRozliczone =
        usedMarketing >= marketingValue && invoiceNumber && invoiceNumber !== 'BRAK';

      const isChanged = edited?.changed;

      const handleSaveOrAccept = () => {
        if (isRozliczone) {
          console.log('✅ Akceptacja rozliczenia:', row);
        } else {
          console.log('💾 Zapisz zmiany:', { row, edited });
        }
        // resetujemy flagę changed
        setEditedRows((prev) => ({
          ...prev,
          [row.id]: { ...prev[row.id], changed: false },
        }));
      };
  if (row.marketing_value === 0) {
      return <span className="text-green-600">ROZLICZONE</span>;
    }
      return (
        
        <Button
          size="small"
          color={isRozliczone ? 'success' : 'secondary'}
          disabled={!isChanged}
          onClick={handleSaveOrAccept}
        >
          {isRozliczone ? 'Akceptuj' : 'Zapisz'}
        </Button>
      );
    },
  },
];


  return (
    <div className="space-y-6">
      <PageHeaderPortal
        title="Rozliczenia marketingowe"
        subtitle="Podsumowanie kosztów marketingowych na podstawie licencji"
      />

      {/* 🔘 Wybór miesiąca */}
      <div className="flex flex-wrap gap-3 items-end">
        <Select
        size="small"
          label="Miesiąc"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(Number(e.target.value))}
          options={months.filter((m) => {
            const now = new Date();
            return (
              m.value <= now.getMonth()+1 ||
              selectedYear < now.getFullYear()
            );
          })}
        />
        <Input
        size="small"
          label="Rok"
          type="number"
          min="2023"
          max={new Date().getFullYear()}
          value={selectedYear}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
          className="w-24"
        />
        <Input
        size="small"
          label="Numer faktury"
          value={invoiceNumber}
          onChange={(e) => setInvoiceNumber(e.target.value)}
          placeholder="np. FV/12/2025"
        />
    
      </div>

      {/* 💰 Kafle kosztów */}
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
     
          <StatCard
          
            label={"Koszty marketingu"}
            value={`${SumMArketing} PLN`}
            description="Suma kosztów"
          />
          <StatCard
          
            label={"Brak faktur"}
            value={`${emptyInvoices}`}
            description="Brak faktur"
          />
          <StatCard
          
            label={"Rozliczono PLN"}
            value={`${Rozliczono} PLN`}
            description="Rozliczono"
          />
           <StatCard
          
            label={"Zostało PLN"}
            value={`${Zostało.toFixed(2)} PLN`}
            description="Zostało"
          />
   
        {rows.length === 0 && !loading && (
          <div className="text-gray-500 text-center py-10">
            Brak danych dla wybranego miesiąca.
          </div>
        )}
      </div>
  <div className="rounded-sm overflow-hidden  border border-gray-200">
 
        <TableMarketing 
        columns={columns}
data={filteredLicenses}
          loading={loading}
        />
      </div>
      <Snackbar
        open={toast.open}
        message={toast.message}
        severity={toast.severity}
        onClose={() => setToast({ ...toast, open: false })}
      />
    </div>
  );
}
